import { SiteHeader } from '../components/homepage/SiteHeader';
import { HeroSection } from '../components/homepage/HeroSection';
import { TrustStrip } from '../components/homepage/TrustStrip';
import { HowItWorks } from '../components/homepage/HowItWorks';
import { ProductOverview } from '../components/homepage/ProductOverview';
import { FeatureStrip } from '../components/homepage/FeatureStrip';
import { MaterialsEcosystem } from '../components/homepage/MaterialsEcosystem';
import { InspirationGallery } from '../components/homepage/InspirationGallery';
import { Testimonials } from '../components/homepage/Testimonials';
import { FAQSection } from '../components/homepage/FAQSection';
import { FinalCTA } from '../components/homepage/FinalCTA';
import { SiteFooter } from '../components/homepage/SiteFooter';

export function Homepage() {
  return (
    <main className="homepage-shell">
      <div className="homepage-card">
        <SiteHeader />
        <HeroSection />
        <TrustStrip />
        <HowItWorks />
        <ProductOverview />
        <FeatureStrip />
        <MaterialsEcosystem />
        <InspirationGallery />
        <Testimonials />
        <FAQSection />
        <FinalCTA />
        <SiteFooter />
      </div>
    </main>
  );
}
